var map = {
	"../password/password.module": [
		"./src/app/password/password.module.ts",
		"password.module"
	],
	"../patients/new-patient/new-patient.module": [
		"./src/app/portal/patients/new-patient/new-patient.module.ts",
		"common"
	],
	"./check-in/check-in-modal.module": [
		"./src/app/portal/patients/check-in/check-in-modal.module.ts",
		"check-in-modal.module"
	],
	"./components/edit-patient/edit-patient.module": [
		"./src/app/portal/patients/patient-detail/components/edit-patient/edit-patient.module.ts",
		"common"
	],
	"./create-facility/create-facility.module": [
		"./src/app/portal/facilities/create-facility/create-facility.module.ts",
		"common",
		"create-facility.module"
	],
	"./dashboard/change-password/change-password.module": [
		"./src/app/portal/dashboard/change-password/change-password.module.ts",
		"change-password.module"
	],
	"./edit-facility/edit-facility.module": [
		"./src/app/portal/facilities/edit-facility/edit-facility.module.ts",
		"common",
		"edit-facility.module"
	],
	"./facilities/facilities.module": [
		"./src/app/portal/facilities/facilities.module.ts",
		"common"
	],
	"./home/home.module": [
		"./src/app/portal/home/home.module.ts",
		"common",
		"home.module"
	],
	"./new-patient/new-patient.module": [
		"./src/app/portal/patients/new-patient/new-patient.module.ts",
		"common"
	],
	"./new-test-order/new-test-order.module": [
		"./src/app/portal/test-order/new-test-order/new-test-order.module.ts",
		"new-test-order.module"
	],
	"./office-staff/office-staff.module": [
		"./src/app/portal/office-staff/office-staff.module.ts",
		"common",
		"office-staff.module"
	],
	"./patient-detail/patient-detail.module": [
		"./src/app/portal/patients/patient-detail/patient-detail.module.ts",
		"common",
		"patient-detail.module"
	],
	"./patients/patients.module": [
		"./src/app/portal/patients/patients.module.ts",
		"common"
	],
	"./portal/portal.module": [
		"./src/app/portal/portal.module.ts",
		"common",
		"portal.module"
	],
	"./reports/reports.module": [
		"./src/app/portal/reports/reports.module.ts",
		"common"
	],
	"./test-order/test-order.module": [
		"./src/app/portal/test-order/test-order.module.ts",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main